import getAxiosClient from "../config/axios";

const getConfigurationsBaseUrl = (endpoint) => {
    return `/api/configurations${endpoint ?? ""}`;
}

const ConfigurationApiClient = {
    fetchAllConfigurations: () => {
        return getAxiosClient().get(getConfigurationsBaseUrl());
    },
    fetchConfigurationByKey: (key) => {
        return getAxiosClient().get(getConfigurationsBaseUrl(`/${key}`));
    },
    fetchConfigurationsByCategory: (category) => {
        return getAxiosClient().get(getConfigurationsBaseUrl(`/category/${category}`));
    },
    updateConfiguration: (key, requestDto) => {
        return getAxiosClient().put(getConfigurationsBaseUrl(`/${key}`), requestDto);
    },
    uploadLogo: (key, file) => {
        const formData = new FormData();
        formData.append('file', file);
        return getAxiosClient().post(getConfigurationsBaseUrl(`/${key}/logo`), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    uploadExcelTemplate: (key, file) => {
        const formData = new FormData();
        formData.append('file', file);
        return getAxiosClient().post(getConfigurationsBaseUrl(`/${key}/excel-template`), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    downloadExcelTemplate: (key) => {
        return getAxiosClient().get(getConfigurationsBaseUrl(`/${key}/excel-template`), {
            responseType: 'blob',
        });
    }
};

export default ConfigurationApiClient;

